import React, {Component} from 'react';
import CommessaSelectList from './CommessaSelectList'
import CommessaSelectListComplete from './CommessaSelectListComplete'
import CommessaSelectDetail from './CommessaSelectDetail'
import PropTypes from 'prop-types';
class CommessaSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            commessa: undefined
        };
        this.onChange = this.onChange.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.commessa !== undefined ){
            this.setState({commessa: nextProps.commessa})
        }
    }

    onChange(commessa) {
        this.props.onChange(commessa);
        this.setState({commessa: commessa})
    }

    render() {
        if (this.state.commessa === undefined)
        {
            if (this.props.commesseList === undefined)
            {
                return (
                    <CommessaSelectList
                        onChange={this.onChange}
                        fluid={this.props.fluid}
                        compact={this.props.compact}
                    />
                )
            }
            else
            {
                return (
                    <CommessaSelectListComplete
                        onChange={this.onChange}
                        fluid={this.props.fluid}
                        compact={this.props.compact}
                        commesseList={this.props.commesseList}
                    />
                )
            }

        }

        return (
            <CommessaSelectDetail
                commessa={this.state.commessa}
                onChange={this.onChange}
                fluid={this.props.fluid}
                compact={this.props.compact}
            />
        )
    }
}

CommessaSelect.PropTypes = {
    onChange: PropTypes.func.isRequired,
    fluid: PropTypes.bool.isRequired,
    compact: PropTypes.bool.isRequired,
    commessa: PropTypes.object.isRequired,
    commesseList: PropTypes.array
}

CommessaSelectList.defaultProps = {
    fluid: false,
    compact: false,
    commessa: undefined,
};
export default CommessaSelect;




/** WEBPACK FOOTER **
 ** ./src/components/commesse/CommessaSelect.js
 **/